<script lang="ts">
    import Fa from 'svelte-fa'
    import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons'
    import FieldHeading from './field-heading.svelte'
    import { ACNE_GRADE_OPTIONS, findAcneGradeOption, type AcneGradeValue } from '../../types/acne-grade'

    export let label: string
    export let data: Record<string, any>
    export let value: AcneGradeValue = null
    export let required = false
    export let readOnly = false

    function select(key: string) {
        if (readOnly) return
        value = key
    }

    $: selectedOption = findAcneGradeOption(value)
</script>

<div class="view-field">
    <FieldHeading {label} {required} {readOnly} />
    <div class="acne-grade">
        {#each ACNE_GRADE_OPTIONS as option (option.key)}
            <button
                type="button"
                class="acne-row"
                class:selected={value === option.key}
                disabled={readOnly}
                on:click={() => select(option.key)}
            >
                <span class="acne-label">
                    {option.label}
                    <span class="acne-tooltip-icon" title={option.tooltip}>
                        <Fa icon={faCircleQuestion} />
                    </span>
                </span>
                <span class="acne-inflammation">{option.inflammation}</span>
                <span class="acne-subtype">{option.subtype}</span>
            </button>
        {/each}
    </div>
</div>

<style>
    .view-field {
        display: flex;
        flex-direction: column;
        width: 100%;
    }
    .acne-grade {
        display: flex;
        flex-direction: column;
        gap: 8px;
        width: 100%;
    }
    .acne-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        width: 100%;
        padding: 10px 14px;
        border: none;
        border-radius: 8px;
        background: #f8f9fa;
        font: inherit;
        text-align: left;
        cursor: pointer;
    }
    .acne-row:disabled {
        cursor: not-allowed;
    }
    .acne-row.selected {
        background: var(--cs2-accent-hover, #17be5e);
    }
    .acne-label {
        display: flex;
        align-items: center;
        gap: 6px;
        flex: 1;
        min-width: 0;
        font-weight: 600;
        font-size: 0.85rem;
        color: #212529;
    }
    .acne-row.selected .acne-label {
        color: #1f2937;
    }
    .acne-inflammation {
        flex: 1;
        min-width: 0;
        text-align: center;
        font-size: 0.85rem;
        color: #495057;
    }
    .acne-subtype {
        flex: 1;
        min-width: 0;
        text-align: right;
        font-size: 0.85rem;
        color: #495057;
    }
    .acne-row.selected .acne-inflammation,
    .acne-row.selected .acne-subtype {
        color: #1f2937;
    }
    .acne-tooltip-icon {
        font-size: 0.72rem;
        color: #adb5bd;
        cursor: help;
    }
    .acne-row.selected .acne-tooltip-icon {
        color: #1f2937;
        opacity: 0.75;
    }
</style>
